import "core-js/stable";
import "regenerator-runtime/runtime.js";
// const intl = require('@formatjs/intl');
// import {createIntl, parse, createIntlCache} from '@formatjs/intl';
import IntlMessageFormat from 'intl-messageformat';
// const LangSource = require('../../Web/local/lang.mjs').default;
import cssVars from 'css-vars-ponyfill';
import { fetch as fetchPolyfill } from 'whatwg-fetch';
import {
	ProfileStorage,
	PROFILE_KEYS,
	storage,
	loadHeaderMenu,
	setKendoMessages,
	setKendoCulture,
	createHierarchyTree,
	validateFilters,
	process_fast_locations,
	getCookie,
} from 'internalhs/sw2.mjs';
import { FIELD_TYPES } from 'internalhs/constants.mjs';
import TreeWidget from '@widgetjs/tree';
if (!window.$) {
	import('jquery');
}

window.sw2 = window.sw2 || {};
sw2.getCookie = getCookie;
sw2._global_id_count = 0;
sw2.fetchPolyfill = fetchPolyfill;
sw2.TreeWidget = TreeWidget;
sw2.TreeWidget.createLiEle = function (node, closed) {
	var li = document.createElement('li');
	li.classList.add('treejs-node');
	if (closed) {
		li.classList.add('treejs-node__close');
	}
	var div = document.createElement('div');
	li.appendChild(div);
	if (node.children && node.children.length) {
		var switcher = document.createElement('span');
		switcher.classList.add('treejs-switcher');
		div.appendChild(switcher);
	} else {
		li.classList.add('treejs-placeholder');
	}

	var checkbox = document.createElement('span');
	checkbox.classList.add('treejs-checkbox');
	div.appendChild(checkbox);
	var label = document.createElement('span');
	label.classList.add('treejs-label');
	var text = document.createTextNode(node.text);
	label.appendChild(text);
	div.appendChild(label);
	li.nodeId = node.id;
	return li;
};
sw2.TreeWidget.prototype.bindEvent = function (ele) {
	ele.addEventListener(
		'click',
		e => {
			const { target } = e;
			if (
				target.nodeName === 'SPAN' &&
				(target.classList.contains('treejs-checkbox') ||
					target.classList.contains('treejs-label'))
			) {
				this.onItemClick(target.parentNode.parentNode.nodeId);
			} else if (
				target.nodeName === 'SPAN' &&
				target.classList.contains('treejs-switcher')
			) {
				this.onSwitcherClick(target.parentNode);
			}
		},
		false
	);
};
try {
	if (top.sw2 && top.sw2.profileStorage) {
		sw2.profileStorage = top.sw2.profileStorage;
	} else {
		sw2.profileStorage = new ProfileStorage();
	}
} catch (error) {
	sw2.profileStorage = new ProfileStorage();
}
sw2.PROFILE_KEYS = PROFILE_KEYS;
sw2.noop = function () { };
sw2.test_mode = 1;
sw2.loadHeaderMenu = loadHeaderMenu;
sw2.noop = function () { };
sw2.createHierarchyTree = createHierarchyTree;
sw2.validateFilters = validateFilters;
sw2.process_fast_locations = process_fast_locations;
sw2.FIELD_TYPES = FIELD_TYPES;

sw2.defaultLanguagesApp = {
	"en": "English",
	"de": "Deutsch",
	"es": "Español",
	"fr": "Français",
	"fr-ca": "Français canadien",
	"ja": "日本語",
	"pt": "Português",
	"ko": "한국어",
	"pl": "Polski",
	"it": "Italiano",
	"zh": "官話",
	"en-gb": "English (UK)",
	"ru": "Pусский",
	"nl": "Nederlands",
	"hu": "Magyar"
};

sw2.defaultLanguages = {
	"en": "English",
	"de": "Deutsch",
	"es": "Español",
	"fr": "Français",
	"fr-ca": "Français canadien",
	"pt": "Português",
};

sw2.updateTheme = function () {
	const {
		theme = {}
	} = sw2.settingsService;
	let variables = {
		'--primary-color': theme.primarycolor || '#4ea5b7',
		'--primary-button-color': theme.primarybuttoncolor || '#4ea5b7',
		'--primary-background-color': theme.primarybackgroundcolor || '#373737',
		'--primary-background-label-color': theme.primarybackgroundlabelcolor || '#4ea5b7',
		'--primary-background-title-color': theme.primarybackgroundtitlecolor || '#FFFFFF',
		'--primary-background-hint-color': theme.primarybackgroundhintcolor || '#878787',
		'--secondary-background-color': theme.secondarybackgroundcolor || '#4ea5b7',
		'--secondary-background-label-color': theme.secondarybackgroundlabelcolor || '#FFFFFF',
		'--secondary-background-title-color': theme.secondarybackgroundtitlecolor || '#FFFFFF',
		'--menu-background-color': sw2.settingsService.custombannerurl ? 'transparent' : '#FFFFFF',
		'--menu-text-color': sw2.settingsService.custombannerurl ? '#FFFFFF' : '#787878',
		'--menu-hover-background-color': sw2.settingsService.custombannerurl ? theme.primarycolor : '#787878',
		'--custombannerurl': sw2.settingsService.custombannerurl ? `url(${sw2.settingsService.custombannerurl})` : 'none',
		'--header-caption-display': sw2.settingsService.customlogourl ? 'none' : 'block',
		'--secondary-button-color': theme.secondarybuttoncolor,
		'--secondary-button-stroke-color': theme.secondarybuttonstrokecolor,
		'--secondary-button-text-color': theme.secondarybuttontextcolor,
		'--primary-button-text-color': theme.primarybuttontextcolor || '#FFFFFF',
		'--tertiary-button-color': theme.tertiarybuttoncolor || '#ECECEC',
		'--tertiary-button-text-color': theme.tertiarybuttontextcolor || '#323642',
		'--danger-button-color': theme.dangerbuttoncolor || '#FF595E',
		'--danger-button-text-color': theme.dangerbuttontextcolor || '#FFFFFF',
		'--tw-bg-opacity': 1,
		'--tw-space-x-reverse': 0,
		'--tw-border-opacity': 1,
		'--tw-translate-x': 0,
		'--tw-translate-y': 0,
		'--tw-rotate': 0,
		'--tw-skew-x': 0,
		'--tw-skew-y': 0,
		'--tw-scale-x': 1,
		'--tw-scale-y': 1,
		'--tw-text-opacity': 1,
		'--tw-shadow': 0,
	};

	cssVars({
		rootElement: document,
		shadowDOM: false,

		// Sources
		include: 'link[rel=stylesheet],style',
		exclude: '',
		variables,
		// Options
		onlyLegacy: false,
		preserveStatic: true,
		preserveVars: true,
		silent: true,
		updateDOM: false,
		updateURLs: true,
		watch: true
	});

	sw2.updateTheme = function () {
		const {
			theme = {}
		} = sw2.settingsService;
		let variables = {
			'--primary-color': theme.primarycolor || '#4ea5b7',
			'--primary-button-color': theme.primarybuttoncolor || '#4ea5b7',
			'--primary-background-color': theme.primarybackgroundcolor || '#373737',
			'--primary-background-label-color': theme.primarybackgroundlabelcolor || '#4ea5b7',
			'--primary-background-title-color': theme.primarybackgroundtitlecolor || '#FFFFFF',
			'--primary-background-hint-color': theme.primarybackgroundhintcolor || '#878787',
			'--secondary-background-color': theme.secondarybackgroundcolor || '#4ea5b7',
			'--secondary-background-label-color': theme.secondarybackgroundlabelcolor || '#FFFFFF',
			'--secondary-background-title-color': theme.secondarybackgroundtitlecolor || '#FFFFFF',
			'--secondary-background-hint-color': theme.secondarybackgroundhintcolor || '#e0e0e0',
			'--menu-background-color': sw2.settingsService.custombannerurl ? 'transparent' : '#FFFFFF',
			'--menu-text-color': sw2.settingsService.custombannerurl ? '#FFFFFF' : '#787878',
			'--menu-hover-background-color': sw2.settingsService.custombannerurl ? theme.primarycolor : '#787878',
			'--custombannerurl': sw2.settingsService.custombannerurl ? `url(${sw2.settingsService.custombannerurl})` : 'none',
			'--header-caption-display': sw2.settingsService.customlogourl ? 'none' : 'block',
			'--secondary-button-color': theme.secondarybuttoncolor,
			'--secondary-button-stroke-color': theme.secondarybuttonstrokecolor,
			'--secondary-button-text-color': theme.secondarybuttontextcolor,
			'--tertiary-button-color': theme.tertiarybuttoncolor || '#ECECEC',
			'--tertiary-button-text-color': theme.tertiarybuttontextcolor || '#323642',
			'--danger-button-color': theme.dangerbuttoncolor || '#FF595E',
			'--danger-button-text-color': theme.dangerbuttontextcolor || '#FFFFFF',
			'--primary-button-text-color': theme.primarybuttontextcolor || '#FFFFFF',
			'--tw-bg-opacity': 1,
			'--tw-space-x-reverse': 0,
			'--tw-border-opacity': 1,
			'--tw-translate-x': 0,
			'--tw-translate-y': 0,
			'--tw-rotate': 0,
			'--tw-skew-x': 0,
			'--tw-skew-y': 0,
			'--tw-scale-x': 1,
			'--tw-scale-y': 1,
			'--tw-text-opacity': 1,
			'--tw-shadow': 0,
		};

		if (theme.secondarybackgroundcolor && theme.secondarybackgroundlabelcolor && theme.secondarybackgroundcolor === theme.secondarybackgroundlabelcolor) {
			variables['--secondary-background-label-color'] = invertColor(theme.secondarybackgroundcolor, true);
		}

		if (theme.buttonTextColor && theme.primarybuttontextcolor.toLowerCase() !== '#fff' && theme.primarybuttontextcolor.toLowerCase() !== '#ffffff') {
			variables['--primary-button-text-color'] = theme.primarybuttontextcolor;
			variables['--menu-hover-text-color'] = sw2.settingsService.custombannerurl ? theme.primarybuttontextcolor : '#FFFFFF';
		} else {
			variables['--primary-button-text-color'] = '#FFFFFF';
			variables['--menu-hover-text-color'] = '#FFFFFF';
		}
		cssVars({
			variables
		});
	};
	sw2.updateTheme();
};

sw2.getAllLanguages = () => {
	if (!sw2._request_cache) {
		sw2._request_cache = {};
	}
	const CACHE_KEY = 'all_languages';
	if (!sw2._request_cache[CACHE_KEY]) {
		sw2._request_cache[CACHE_KEY] = new window.WebServicePromise({
			url: '/webapi/languages/getalllanguages',
			headers: {
				auth_token: sw2.loginService?.logintoken
			},
			data: null,
			type: 'GET'
		}).then((resp) => {
			return resp.map(lang => {
				lang.id = lang.languageid;
				delete lang.languageid;
				return lang;
			});
		}).fail(() => {
			delete sw2._request_cache[CACHE_KEY];
		});
	}
	return sw2._request_cache[CACHE_KEY];
};

function preparse(collector, locale, node, ancestor) {
	for (let key in node) {
		/* use this for debugging malformed yaml */
		// console.log('ancestor:', ancestor, ' key:', key, ' node val:', node[key]);
		if (typeof node[key] === 'object') {
			preparse(collector, locale, node[key], `${ancestor}.${key}`);
		} else {
			try {
				collector[`${ancestor}.${key}`] = new IntlMessageFormat(node[key], locale);
			} catch (e) {
				console.log(`bad intl value ${ancestor}.${key} ${node[key]}`);
				//fake object with format method
				collector[`${ancestor}.${key}`] = {
					format() {
						return node[key];
					}
				};
			}
		}
	}
}

sw2.getTranslationsWithDbToken = function getTranslationsWithDbToken(dbtoken) {
	/* Base translations */
	return sw2.bootstrapApplication(sw2.loginService.locale, ['login'], false, dbtoken).catch(function () {
		return sw2.intl;
	});
};
sw2.processMessages = function processMessages(combinedMessages, locale) {
	const dictionary = {};
	const translationKeys = [];
	Object.keys(combinedMessages).forEach(key => {
		if (key !== 'languageid') {
			translationKeys.push(key);
		}
	});
	for (let ii = 0, len = translationKeys.length; ii < len; ++ii) {
		const path = translationKeys[ii];
		if (combinedMessages[path]) {
			preparse(dictionary, locale, combinedMessages[path], path);
		}
	}
	return dictionary;
};
sw2.bootstrapApplication = async function (locale, paths = ['login'], initialMessages, dbtoken) {
	/* Check local storage for base first - use dbtoken as part of key in case of accessing multiple clients */
	// const STORAGE_KEY = sw2.loginService.internaldbtoken + sw2._appVersion + paths.sort().join();
	let defaultMessages = null;

	if (initialMessages) {
		/* Only retrieve local/static data to hydrate dictionary for login */
		let baseIntl;
		const lang = defineLang(sw2.locale());
		if (lang === 'en') {
			baseIntl = await $.get(`local/data/login.json`);
		} else {
			baseIntl = await $.get(`local/data/${lang}/login.json`);
		}
		defaultMessages = typeof baseIntl === 'string' ? JSON.parse(baseIntl) : baseIntl;
		defaultMessages['languageid'] = lang;
	} else if (dbtoken && !sw2.loginService.logintoken) {
		/* Only retrieve client specific translations for login */
		defaultMessages = await sw2.noAuthIntl.loadTranslationsNoAuth(dbtoken, defineLang(locale.toLowerCase()));
		defaultMessages.languageid = defaultMessages.languageid.toLowerCase();
	} else {
		/* Get full base translations */
		defaultMessages = {};
	}
	let messages = defaultMessages;
	if (!initialMessages && !dbtoken && locale !== defaultMessages.languageid) {
		/* Get specific translations for locale */
		messages = await sw2.authIntl.loadTranslations(locale, paths);
		messages.languageid = messages.languageid.toLowerCase();
	}
	return sw2.processMessages(messages, messages.languageid);
};

sw2.noAuthIntl = {
	loadTranslationsNoAuth: async function (dbtoken, locale) {
		let messages = await this.loadDbTokenData(dbtoken, locale);

		if (!messages) {
			messages = this.getLocalStorageNoAuth(locale);
		} else {
			this.setLocalStorageNoAuth(locale, messages);
		}
		return messages;
	},
	setLocalStorageNoAuth: function (locale, messages) {
		try {
			const language = getLangFromLocalStorage(locale);
			if (language?.version) {
				Object.keys(storage).forEach(function (storage_key) {
					if (storage_key.indexOf(`login_`) > -1) {
						//remove old keys
						storage.removeItem(storage_key);
					}
				});
				storage.setItem(`login_${language.version}`, JSON.stringify(messages));
			}
		} catch (e) {
			//ignore
		}
	},
	getLocalStorageNoAuth: function (locale) {
		const language = getLangFromLocalStorage(locale);
		return JSON.parse(storage.getItem(`login_${language?.version}`));
	},
	loadDbTokenData: function (dbtoken, locale) {
		const language = getLangFromLocalStorage(locale);
		const doWeHaveCachedTranslations = this.checkForNoAuthCache(language?.version);
		return new window.WebServicePromise({
			url: '/webapi/languages/getlanguagepacknoauth',
			headers: {
				'sw2-language-version': doWeHaveCachedTranslations ? language?.version : null,
			},
			data: {
				dbtoken: dbtoken,
				languageid: locale,
			}
		});
	},
	checkForNoAuthCache: function (version) {
		const cachedLangKeys = Object.keys(storage).filter(function (storage_key) {
			return storage_key === `login_${version}`;
		})[0];
		return !!cachedLangKeys;
	}
};

sw2.authIntl = {
	getlocalStorageKeyWord: (locale) => locale === 'en' ? 'baseIntl' : 'currIntl',
	loadTranslations: function (locale, paths) {
		if (sw2.settingsService.webservice === 'SchedulerWS') {
			// clean up localstorage outside of apps
			this.clearStorageCache('en');
			this.clearStorageCache('!en');
		}
		return this.loadLocaleData(locale, paths).then((messages) => {
			if (sw2.settingsService.webservice && sw2.settingsService.webservice !== 'SchedulerWS') {
				//we still need this for offline mode for apps
				this.setLocalStorageWithExpiry(locale, messages);
			}
			return messages;
		});
	},
	loadLocaleData: function (locale, paths) {
		if (!sw2._request_cache) {
			sw2._request_cache = {};
		}
		const CACHE_KEY = locale + paths.sort().join();
		if (!sw2._request_cache[CACHE_KEY]) {
			const version = this.getVersionFromLocalStorage(locale);
			const params = `km=${encodeURIComponent(paths.join(','))}&l=${encodeURIComponent(locale)}`;
			sw2._request_cache[CACHE_KEY] = new window.WebServicePromise({
				url: `/webapi/languages/getlanguagepack?${params}`,
				headers: {
					auth_token: sw2.loginService?.logintoken,
					'sw2-language-version': version,
				},
				data: null,
				type: 'GET'
			}).then((response, type, xhr) => {
				try {
					const new_language_version = xhr.getResponseHeader('Sw2-Language-Version');
					this.setVersionToLocalStorage(locale, new_language_version);
				} catch (error) {
					this.clearStorageCache();
				}
				return response;
			}).fail(() => {
				delete sw2._request_cache[CACHE_KEY];
			});
		}
		return sw2._request_cache[CACHE_KEY];
	},
	setLangsToLocalStorage: function (langs) {
		const languages = storage.getItem('langs');
		if (languages) {
			storage.removeItem('langs');
		}
		storage.setItem('langs', JSON.stringify(langs));
	},
	getVersionFromLocalStorage: function (locale) {
		const keyWord = this.getlocalStorageKeyWord(locale);
		return storage.getItem(`${keyWord}_version`);
	},
	setVersionToLocalStorage: function (locale, version) {
		const keyWord = this.getlocalStorageKeyWord(locale);
		storage.setItem(`${keyWord}_version`, version);
	},
	clearStorageCache: function (locale) {
		try {
			const keyWord = this.getlocalStorageKeyWord(locale);
			Object.keys(storage).forEach(function (storage_key) {
				if (storage_key.indexOf(`${keyWord}`) === 0 && storage_key.indexOf('_login') === -1 && sw2.loginService.logintoken && storage_key.indexOf('_version') === -1) {
					//remove old keys
					storage.removeItem(storage_key);
				}
			});
		} catch (e) {
			//ignore
		}
	},
	setLocalStorageWithExpiry: function (locale, messages /*, _*/) {
		try {
			const version = this.getVersionFromLocalStorage(locale);
			if (version) {
				const keyWord = this.getlocalStorageKeyWord(locale);
				Object.keys(storage).forEach(function (storage_key) {
					if (storage_key.indexOf(`${keyWord}`) === 0 && storage_key.indexOf('_login') < 0 && sw2.loginService.logintoken && storage_key.indexOf('_version') < 0) {
						//remove old keys
						storage.removeItem(storage_key);
					}
				});
				for (let [packName, translations] of Object.entries(messages)) {
					storage.setItem(`${keyWord}_${version}_${packName}`, JSON.stringify(translations));
				}
			}
		} catch (e) {
			//ignore
		}
	},
	getLocalStorageWithExpiry: function (locale, paths) {
		/* ****************************************************
		TODO: local storage disabled temporarily
		**************************************************** */
		if (window._debug) {
			return null;
		}
		try {
			const keyWord = this.getlocalStorageKeyWord(locale);
			const version = this.getVersionFromLocalStorage(locale);
			let translations = null;
			const cachedLangKeys = Object.keys(storage).filter(function (storage_key) {
				return storage_key.indexOf(`${keyWord}_${version}`) === 0;
			});

			if (!cachedLangKeys.length) {
				return null;
			}
			translations = {};
			cachedLangKeys.forEach((key) => {
				const packName = key.split('_')[2];
				if (paths.filter(path => path === packName)[0] || packName === 'languageid') {
					translations[packName] = JSON.parse(storage.getItem(`${keyWord}_${version}_${packName}`));
				}
			});
			return translations;
		} catch (e) {
			return null;
		}
	},
};

function getLangFromLocalStorage(locale) {
	const langs = JSON.parse(storage.getItem('langs'));
	if (langs) {
		return langs.filter(lang => lang.id === locale)[0];
	}
	return null;
}

function setLang(lang) {
	if ($("html").attr("lang") !== lang) {
		$("html").attr("lang", lang);
	}
}

function defineLang(locale) {
	const languages = Object.keys(sw2.defaultLanguages);
	locale = locale.toLowerCase();
	const fullMatchLanguage = languages.filter(lang => lang === locale)[0];
	const partialMatchLanguage = languages.filter(language => locale.indexOf(language) === 0)[0];
	if (fullMatchLanguage) {
		return fullMatchLanguage;
	} else if (partialMatchLanguage) {
		return partialMatchLanguage;
	} else {
		return 'en';
	}
}

sw2.QRCodeGenerator = function () {
	return import('qrcode').then(module => module.default);
};

sw2.GoogleMaps = function (libraries = ['drawing', 'places', 'visualization']) {
	return import('@googlemaps/js-api-loader')
		.then(module => module.Loader)
		.then(function (Loader) {
			const loader = new Loader({
				apiKey: 'AIzaSyAS6OMMy8M5wSybJAL1h39VGX5jOw60B-0',
				version: 'quarterly',
				libraries
			});
			return loader.load();
		}).then(function (maps) {
			return maps;
		});
};

sw2.setKendoIntl = async (paths) => {
	const messages = JSON.parse(JSON.stringify(await sw2.authIntl.loadTranslations(sw2.locale(), paths)));
	if (messages['kendo']) {
		setKendoMessages(messages['kendo']);
		setKendoCulture(sw2.locale(), messages['culture']);
	}
};

function invertColor(hex, bw) {
	if (hex.indexOf('#') === 0) {
		hex = hex.slice(1);
	}
	// convert 3-digit hex to 6-digits.
	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}
	if (hex.length !== 6) {
		throw new Error('Invalid HEX color.');
	}
	var r = parseInt(hex.slice(0, 2), 16),
		g = parseInt(hex.slice(2, 4), 16),
		b = parseInt(hex.slice(4, 6), 16);
	if (bw) {
		return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ?
			'#000000' :
			'#FFFFFF';
	}
	// invert color components
	r = (255 - r).toString(16);
	g = (255 - g).toString(16);
	b = (255 - b).toString(16);
	// pad each with zeros and return
	return "#" + pad(r, 2) + pad(g, 2) + pad(b, 2);
}

function pad(n, width, z) {
	z = z || '0';
	n = n + '';
	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

sw2.defineLang = defineLang;
sw2.setLang = setLang;
sw2.getLocalStorageWithExpiry = sw2.authIntl.getLocalStorageWithExpiry.bind(sw2.authIntl);
sw2.loadTranslations = sw2.authIntl.loadTranslations.bind(sw2.authIntl);
